import React, { useState } from "react";

// Gerekli ikonları import edelim
import { FaPlus, FaMinus, FaCheckCircle, FaCheck } from "react-icons/fa";

// Stil dosyamızı import edelim
import "./FaqSection.scss";

// Görselleri import edelim
import greenCatIcon from "../../assets/images/green-cat.png";
import faqHekim from "../../assets/images/faq-hekim.png";

// Accordion verilerini bir dizi olarak tanımlıyoruz
const faqData = [
  {
    question: "Randevu nasıl alabilirim?",
    answer:
      "Randevu almak için web sitemizdeki online randevu formunu kullanabilir veya doğrudan kliniğimizi arayabilirsiniz. Acil durumlar için lütfen telefonla iletişime geçin.",
  },
  {
    question: "Hangi tür evcil hayvanlara hizmet veriyorsunuz?",
    answer:
      "Kliniğimizde kedi ve köpek başta olmak üzere birçok evcil hayvana yönelik teşhis, tedavi ve bakım hizmetleri sunulmaktadır. Egzotik hayvanlar için lütfen önceden bilgi alınız.",
  },
  {
    question: "Acil durumlar için 7/24 açık mısınız?",
    answer:
      "Evet, kliniğimiz acil durumlar için 7 gün 24 saat hizmet vermektedir. Nöbetçi hekimlerimiz her zaman görevinin başındadır.",
  },
  {
    question: "Ödeme seçenekleri nelerdir?",
    answer:
      "Nakit ve tüm bankaların kredi kartları ile ödeme kabul etmekteyiz. Anlaşmalı sigorta poliçeleri hakkında bilgi almak için bizimle iletişime geçebilirsiniz.",
  },
];

// Tek bir Accordion elemanı için component
const AccordionItem = ({ question, answer, isOpen, onToggle }) => {
  // Kendi [isOpen, setIsOpen] state'i kaldırıldı.

  return (
    // isOpen prop'una göre active class'ı ekleniyor
    <div className={`accordion-item ${isOpen ? "active" : ""}`}>
      {/* onToggle prop'u ile parent'taki fonksiyon çağrılıyor */}
      <div className="accordion-header" onClick={onToggle}>
        <h4 className="accordion-question">{question}</h4>
        <div className="accordion-icon">
          {isOpen ? <FaMinus /> : <FaPlus />}
        </div>
      </div>
      <div className="accordion-content">
        <p>{answer}</p>
      </div>
    </div>
  );
};

const FaqSection = () => {
  const checkListItems = [
    "Evcil dostlarınızın sağlığı için alanında deneyimli ve özverili bir ekip sunuyoruz.",
    "Hızlı ve doğru teşhis için en son teknolojiye sahip ekipmanlarla çalışıyoruz.",
    "Tüm hizmetlerimizi sevgi, şefkat ve profesyonellikle, evcil hayvanlarınızın mutluluğunu ön planda tutarak sağlıyoruz.",
    "Aşıdan cerrahi müdahalelere, kuaförden pet shop hizmetlerine kadar her ihtiyaca uygun çözümler sunuyoruz.",
  ];

  const [openIndex, setOpenIndex] = useState(null);

  // Tıklanan accordion'un index'ini alıp state'i güncelleyen fonksiyon
  const handleToggle = (index) => {
    // Eğer tıklanan zaten açıksa, kapat (null yap). Değilse, index'ini ayarla.
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-section-wrapper">
      <div className="faq-section page-container">
        {/* Sol Sütun */}
        <div className="faq-left-column">
          <div className="faq-subtitle-wrapper">
            <img src={greenCatIcon} alt="faq icon" className="subtitle-icon" />
            <span className="subtitle-text">Sık Sorulan Sorular</span>
          </div>
          <h2 className="main-title">
            Evcil Hayvanlarınız İçin  Neden Bizi Seçmelisiniz
          </h2>

          <div className="hekim-info-wrapper">
            <img src={faqHekim} alt="Veteriner Hekim" className="hekim-image" />
            <div className="checklist">
              {checkListItems.map((item, index) => (
                <div key={index} className="checklist-item">
                  <FaCheck className="check-icon" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="bottom-line"></div>
        </div>

        {/* Sağ Sütun */}
        <div className="faq-right-column">
          {faqData.map((faq, index) => (
            // --- DEĞİŞİKLİK 3: Gerekli prop'ları AccordionItem'a gönderiyoruz ---
            <AccordionItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index} // Sadece index'i state'deki ile eşleşen açık olacak
              onToggle={() => handleToggle(index)} // Tıklandığında handleToggle'ı çalıştır
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
